import { render } from "./PasswordRecovery.vue?vue&type=template&id=652377f4&scoped=true"
import script from "./PasswordRecovery.vue?vue&type=script&lang=js"
export * from "./PasswordRecovery.vue?vue&type=script&lang=js"

import "./PasswordRecovery.vue?vue&type=style&index=0&id=652377f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652377f4"],['__file',"src/pages/PasswordRecovery.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "652377f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('652377f4', __exports__)) {
    api.reload('652377f4', __exports__)
  }
  
  module.hot.accept("./PasswordRecovery.vue?vue&type=template&id=652377f4&scoped=true", () => {
    api.rerender('652377f4', render)
  })

}


export default __exports__